$(document).ready(function(){

    var scroll = $(window).scrollTop();

    if (scroll >= 200) {
        $("#back-to-top").addClass("active");
    }

    // Back to top button
    $('#back-to-top').on('click', function(e){
        e.preventDefault();
        $(this).removeClass('active');
        $('html,body').animate({
            scrollTop: 0
        }, 500)
    });

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 200) {
            $("#back-to-top").addClass("active");
        }else{
            $("#back-to-top").removeClass("active");
        }
    });

    $('img.lazy').Lazy({
        effect: 'fadeIn',
        effectTime: 1500,
        visibleOnly: false
    });
});